/**
 * Tiny pub/sub bridging non-React code (axios interceptor, ChatService SSE
 * reader) to the QuotaContext provider. A "quota_exceeded" payload published
 * here is the backend's 429 detail / SSE frame body verbatim
 * (catax_ai/bl/usage_meter.py quota_payload).
 */

export interface QuotaExceededPayload {
  error: 'quota_exceeded';
  metric: string; // orders | part_queries | llm_queries
  used: number;
  limit: number | null;
  plan_id: string | null;
  resets_at: string; // ISO datetime
  message?: string;
}

type Listener = (payload: QuotaExceededPayload) => void;

const listeners = new Set<Listener>();

export const quotaBus = {
  publish(payload: QuotaExceededPayload): void {
    listeners.forEach((listener) => {
      try { listener(payload); } catch { /* listener errors never break callers */ }
    });
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
